import { Application } from '@hotwired/stimulus'
import { sendError } from '../utils'

const application = Application.start()
// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Replaces @appsignal/stimulus's installErrorHandler, which reports the identifier and message only,
// leaving no way to find the offending page.
application.handleError = (error, message, detail = {}) => {
  console.error(message, error, detail)

  sendError(error, detail.identifier || '[unknown Stimulus controller]', {
    framework: 'Stimulus',
    message,
    referrer: document.referrer,
    // cloneNode(false) keeps the opening tag without its children,
    // truncated because Tailwind classes alone blow up the tag size.
    element: detail.element?.cloneNode(false).outerHTML.slice(0, 300) ?? '',
  })
}

import Dropdown from '@stimulus-components/dropdown'
application.register('dropdown', Dropdown)

export { application }
